import React from 'react';

import { RegexEnum } from '../../libs/enums';
import { mustBeBeforeDate, mustBeFilled, mustMatchFormat } from '../../libs/validators';

export const inputBirthdateConfig = {
  autoComplete: 'bday',
  description: () => (
    <React.Fragment>
      En cas de date de naissance présumée, renseignez 00 sur les périodes inconnues.
      <br />
      Format : JJ/MM/AAAA
    </React.Fragment>
  ),
  label: 'Date de naissance',
  maxLength: 10,
  name: 'birthdate',
  validators: {
    format: [
      mustMatchFormat(
        RegexEnum.BIRTHDATE,
        'Veuillez respecter le format JJ/MM/AAAA pour renseigner votre date de naissance',
      ),
      mustMatchFormat(
        RegexEnum.BIRTHDATE_AFTER_1799,
        'Vous devez renseigner une date correspondant à votre date de naissance',
      ),
      mustBeBeforeDate(),
    ],
    submit: mustBeFilled('Veuillez renseigner votre date de naissance'),
  },
};
